// @ts-nocheck
import React from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet, Platform, ViewProps, View } from 'react-native';

interface SwiftUIGlassCardProps extends ViewProps {
  children: React.ReactNode;
  intensity?: number;
  cornerRadius?: number;
  style?: any;
  contentStyle?: any;
}

export default function SwiftUIGlassCard({
  children,
  intensity = 0.6,
  cornerRadius = 24,
  style,
  contentStyle,
  ...props
}: SwiftUIGlassCardProps) {
  if (Platform.OS !== 'ios') {
    // Fallback for non-iOS platforms with no @expo/ui dependency
    return (
      <View
        style={[
          styles.fallbackCard,
          {
            borderRadius: cornerRadius,
            backgroundColor: `rgba(15, 23, 42, ${0.45 + intensity * 0.3})`,
          },
          style,
        ]}
        {...props}
      >
        <View style={[styles.fallbackContent, contentStyle]}>{children}</View>
      </View>
    );
  }

  // iOS path: require @expo/ui only when running on iOS to avoid web runtime import
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { Host } = require('@expo/ui/swift-ui');
  return (
    <Host style={style} {...props}>
      {/* SwiftUI Glass Effect */}
      <LinearGradient
        colors={[
          `rgba(255, 255, 255, ${0.1 * intensity})`,
          `rgba(255, 255, 255, ${0.05 * intensity})`,
          `rgba(255, 255, 255, ${0.02 * intensity})`,
        ]}
        startPoint={{ x: 0, y: 0 }}
        endPoint={{ x: 1, y: 1 }}
        style={[
          styles.glassBackground,
          {
            borderRadius: cornerRadius,
            opacity: intensity,
          },
        ]}
      >
        <Host
          style={[
            styles.glassContent,
            {
              borderRadius: cornerRadius,
              backgroundColor: `rgba(15, 23, 42, ${0.25 * intensity})`,
              backdropFilter: `blur(${20 * intensity}px)`,
              WebkitBackdropFilter: `blur(${20 * intensity}px)`,
            },
            contentStyle,
          ]}
        >
          {children}
        </Host>
      </LinearGradient>
    </Host>
  );
}

const styles = StyleSheet.create({
  glassBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  glassContent: {
    flex: 1,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgba(148, 163, 184, 0.38)',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },
  fallbackCard: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgba(148, 163, 184, 0.38)',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 5,
    overflow: 'hidden',
  },
  fallbackContent: {
    flex: 1,
    padding: 16,
  },
});
